<template>
    <transition name="fade">
        <div class="see-more-player-modal" @click="onClickOverlay">
            <div class="close fixed text-right">
                <i @click="closeModal" class="fas text-white fa-times text-3xl shadow-text-none cursor-pointer"></i>
            </div>
            <div class="text-center text-white">
                <h3 class="font-size-24 mb-1">{{ players.length }} {{ $t('more_player_joined') }}</h3>
                <ul class="block list-reset my-0 overflow-y-auto">
                    <li
                        class="uppercase font-size-20 lg:font-size-24 mb-1"
                        :key="index"
                        v-for="(player, index) in players"
                    >
                        <span>{{ player }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['players'],

    methods: {
        closeModal() {
            this.$emit('close')
        },

        onClickOverlay(e) {
            if (e.target.classList.toString().indexOf('see-more-player-modal') > -1) {
                this.closeModal()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.see-more-player-modal {
    background-color: rgba(0, 0, 0, .7);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    font-size: .5rem;
    z-index: 9999;
    overflow: auto;
    padding: 1rem;
    display: flex;
    justify-content: center;

    .close {
        top: 1rem;
        right: 1rem;
    }
}
</style>
